module.exports = __webpack_public_path__ + "static/media/failScanTL.svg";